export default  {
  bindings: {
    details: '<',
  },
  controller: 'membershipDiscountController',
  template: require('../views/membershipDiscount.html')
};




// WEBPACK FOOTER //
// ./frontend/admin/app/modules/discounts/components/membershipDiscount.component.js